import script from "./RelatabilitySlider.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatabilitySlider.vue?vue&type=script&setup=true&lang=js"

import "./RelatabilitySlider.vue?vue&type=style&index=0&id=62ed9ab0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62ed9ab0"]])

export default __exports__